import React, {useEffect, useRef, useState} from "react";
import {useHistory, useParams} from "react-router-dom";
import {Icon, Loader} from "semantic-ui-react";
import useSubscribe from "../Hooks/useSubscribe";
import keys from "../translations/keys";
import {useTranslation} from "react-i18next";

const SuccessPayment = () => {
    let {id} = useParams<{ id: string | undefined }>();
    const {push} = useHistory();
    const {getTransactionById} = useSubscribe();
    const getTransaction = useRef(getTransactionById);
    getTransaction.current = getTransactionById;
    const [status, setStatus] = useState(false);
    const [days, setDays] = useState(0);
    const {t} = useTranslation();
    useEffect(() => {
        let cancelled = false;
        let timeout: ReturnType<typeof setTimeout>;
        setStatus(false);
        setDays(0);

        const fetch = async () => {
            if (!id)
                return;

            let confirmed = false;
            try {
                const response = await getTransaction.current(id);
                if (cancelled)
                    return;

                if (response?.isSuccess) {
                    confirmed = true;
                    setStatus(true);
                    setDays(response.days);
                    return;
                }
            } catch {
                return;
            } finally {
                if (!cancelled && !confirmed)
                    timeout = setTimeout(fetch, 3000);
            }
        }
        fetch();
        return () => {
            cancelled = true;
            clearTimeout(timeout);
        }
    }, [id]);

    useEffect(() => {
        if (!status)
            return;

        const timeout = setTimeout(() => push('/main'), 5000);
        return () => clearTimeout(timeout);
    }, [status, push])

    const getIcon = () => {
        if (status) {
            return <Icon className="status_icon" name={'check circle outline'} size={"massive"} color={'green'}/>
        } else {
            return <Icon className="status_icon" name={'wait'} size={"massive"} color={'orange'}/>
        }
    }

    const text = t(keys.notifications.added) + t(keys.day.day, {count: Number(days)});
    return (
        <div className="success_payment_page">
            <div className="success_payment_page__container">
                {getIcon()}
                {status ? <>
                        <div className={'container__text success'}>{t(keys.notifications.successDone)}!</div>
                    </> :
                    <div className={'container__text'}>{t(keys.notifications.processing)} #{id}</div>
                }

                {!status && <div className={'container__sub'}>{t(keys.notifications.processingDescription)}</div>}
                {status && <div className={'container__success'}>{text}</div>}
                <div className="container__loader">
                    <Loader active={!status} inverted/>
                </div>
            </div>
        </div>
    )
}

export default SuccessPayment;
